import { BPCTableField } from '@shared/interfaces/bpc-table-interface';

export const posSessionSyncDisplayFields = {
  date: {
    displayType: 'date',
    key: 'date',
  },
  pos_box_name: {
    displayType: 'text',
    key: 'pos_box_name',
  },
  total_sales: {
    displayType: 'currency',
    key: 'totalSales',
  },
  total_payments: {
    displayType: 'currency',
    key: 'totalPayments',
  },
  validation_status: {
    displayType: 'badge',
    valueToLabel: [
      {
        value: 'opened',
        label: 'accounting_integrations.sale_days_sync.validation_status.opened.label',
      },
      {
        value: 'closed',
        label: 'accounting_integrations.sale_days_sync.validation_status.closed.label',
      },
    ],
    valueToVariant: [
      { value: 'opened', variant: 'warning' },
      { value: 'closed', variant: 'success' },
    ],
  },
  sync_status: {
    displayType: 'badge',
    valueToLabel: [
      {
        value: 'to_process',
        label: 'accounting_integrations.sale_days_sync.sync_status.to_process.label',
      },
      {
        value: 'pending',
        label: 'accounting_integrations.sale_days_sync.sync_status.to_process.label',
      },
      {
        value: 'synced',
        label: 'accounting_integrations.sale_days_sync.sync_status.synced.label',
      },
      {
        value: 'failed',
        label: 'accounting_integrations.sale_days_sync.sync_status.failed.label',
      },
      {
        value: null,
        label: 'accounting_integrations.sale_days_sync.sync_status.to_process.label',
      },
    ],
    valueToVariant: [
      { value: 'to_process', variant: 'info' },
      { value: 'pending', variant: 'info' },
      { value: 'synced', variant: 'success' },
      { value: 'failed', variant: 'danger' },
      { value: null, variant: 'warning' },
    ],
  },
};

export const tableFields: BPCTableField[] = [
  {
    key: 'date',
    headerLabel: 'accounting_integrations.sale_days_sync.date.label',
    order: 0,
    displayType: 'date',
  },
  {
    key: 'pos_box_name',
    headerLabel: 'accounting_integrations.sale_days_sync.journal.label',
    order: 1,
  },
  {
    key: 'totalSales',
    headerLabel: 'accounting_integrations.sale_days_sync.total_sales.label',
    order: 2,
    displayType: 'currency',
  },
  {
    key: 'totalPayments',
    headerLabel: 'accounting_integrations.sale_days_sync.total_payments.label',
    order: 3,
    displayType: 'currency',
  },
  {
    key: 'validation_status',
    headerLabel: 'accounting_integrations.sale_days_sync.validation_status.label',
    order: 4,
    displayType: 'badge',
  },
  {
    key: 'sync_status',
    headerLabel: 'accounting_integrations.sale_days_sync.status.label',
    order: 5,
    displayType: 'badge',
  },
];

export const detailsTabConfig = {
  mainInfo: {
    fields: [
      'date',
      'pos_box_name',
      'total_sales',
      'total_payments',
      'validation_status',
      'sync_status',
    ],
  },
  tabs: [
    {
      id: 'pos_sessions',
      label: 'accounting_integrations.sale_day_sync.details.tabs.pos_sessions.label',
      lazy: false,
    },
    {
      id: 'sales_by_article',
      label: 'accounting_integrations.sale_day_sync.details.tabs.sales_by_article.label',
      lazy: false,
    },
    {
      id: 'sales_by_account',
      label: 'accounting_integrations.sale_day_sync.details.tabs.sales_by_account.label',
      lazy: false,
    },
    {
      id: 'payments_by_type',
      label: 'accounting_integrations.sale_day_sync.details.tabs.payments_by_type.label',
      lazy: false,
    },
    {
      id: 'errors',
      label: 'accounting_integrations.sale_day_sync.details.tabs.pos_errors.label',
      lazy: true,
    },
  ],
};

export const salesByArticleTableFields: BPCTableField[] = [
  {
    key: 'articleName',
    headerLabel: 'accounting_integrations.sale_day_sync.details.article.label',
    order: 0,
  },
  {
    key: 'unitPrice',
    headerLabel: 'accounting_integrations.sale_day_sync.details.unit_price.label',
    order: 1,
    displayType: 'currency',
  },
  {
    key: 'count',
    headerLabel: 'accounting_integrations.sale_day_sync.details.quantity.label',
    order: 2,
  },
  {
    key: 'totalAmount',
    headerLabel: 'accounting_integrations.sale_day_sync.details.total.label',
    order: 3,
    displayType: 'currency',
  },
];

export const salesByAccountTableFields: BPCTableField[] = [
  {
    key: 'accountNumber',
    displayType: 'badge',
    headerLabel: 'accounting_integrations.sale_day_sync.account_number.label',
    order: 0,
  },
  {
    key: 'accountName',
    headerLabel: 'accounting_integrations.sale_day_sync.account_name.label',
    order: 1,
  },
  {
    key: 'analyticCode',
    headerLabel: 'accounting_integrations.sale_day_sync.analytic_code.label',
    order: 2,
  },
  {
    key: 'count',
    headerLabel: 'accounting_integrations.sale_day_sync.details.quantity.label',
    order: 3,
  },
  {
    key: 'totalTaxAmount',
    headerLabel: 'accounting_integrations.sale_day_sync.total_tax_amount.label',
    order: 4,
    displayType: 'currency',
  },
  {
    key: 'totalAmount',
    headerLabel: 'accounting_integrations.sale_day_sync.details.total.label',
    order: 5,
    displayType: 'currency',
  },
];

export const paymentsByTypeTableFields: BPCTableField[] = [
  {
    key: 'paymentMethodLabel',
    headerLabel: 'accounting_integrations.sale_day_sync.payment_method.label',
    order: 0,
  },
  // {
  //   key: 'paymentMethodCode',
  //   headerLabel: 'accounting_integrations.sale_day_sync.payment_method_code.label',
  //   order: 1,
  // },
  {
    key: 'totalAmount',
    headerLabel: 'accounting_integrations.sale_day_sync.details.total.label',
    order: 2,
    displayType: 'currency',
  },
];

export const posSessionSyncFieldConfig = {
  date: {
    label: 'accounting_integrations.sale_days_sync.date.label',
    placeholder: 'accounting_integrations.sale_days_sync.date.placeholder',
    required: true,
  },
  journal: {
    label: 'accounting_integrations.sale_days_sync.journal.label',
    placeholder: 'accounting_integrations.sale_days_sync.journal.placeholder',
    required: true,
  },
  total_sales: {
    label: 'accounting_integrations.sale_days_sync.total_sales.label',
    placeholder: 'accounting_integrations.sale_days_sync.total_sales.placeholder',
    type: 'number',
    required: true,
  },
  total_payments: {
    label: 'accounting_integrations.sale_days_sync.total_payments.label',
    placeholder: 'accounting_integrations.sale_days_sync.total_payments.placeholder',
    type: 'number',
    required: true,
  },
  validation_status: {
    label: 'accounting_integrations.sale_days_sync.validation_status.label',
    required: true,
  },
  sync_status: {
    label: 'accounting_integrations.sale_days_sync.sync_status.label',
    required: true,
  },
};

export const posSessionSyncTableFields: BPCTableField[] = [
  { key: 'code', headerLabel: 'accounting_integrations.sale_days_sync.code.label', order: 0 },
  { key: 'contact', headerLabel: 'accounting_integrations.sale_days_sync.contact.label', order: 1 },
  {
    key: 'timeRange',
    headerLabel: 'accounting_integrations.sale_days_sync.time_range.label',
    order: 2,
  },
  {
    key: 'correctBalance',
    headerLabel: 'accounting_integrations.sale_days_sync.correct_balance.label',
    order: 3,
  },
];

export const errorsTableFields: BPCTableField[] = [
  { key: 'sign', headerLabel: 'accounting_integrations.sale_days_sync.error_sign.label', order: 0 },
  {
    key: 'totalAmount',
    headerLabel: 'accounting_integrations.sale_day_sync.details.total.label',
    order: 1,
    displayType: 'currency',
  },
];
